import React from "react";
import { Container, Row, Col, Image, Figure } from "react-bootstrap";
import { connect } from "react-redux";
import { macaDishesTable } from "../firebase/content";
import Editable from "./Editable";

class MacaDishes extends React.Component {
  imageUrl(image) {
    return (this.props.images.find((x) => x.name === image) || {}).url;
  }

  render() {
    let { editable } = this.props;
    let { [macaDishesTable]: macaDishes } = this.props.content;
    macaDishes = macaDishes || {};
    const images = (macaDishes.dishImages || []).map((dish) => dish.image);
    return (
      <div className="maca-dishes-section" id="maca-dishes">
        <Container fluid className="maca-dishes-content">
          <Row className="dishes-content-text">
            <Col sm={12} md={6}>
              <div>
                <h1>VÀO BẾP CÙNG MACA VẠN PHÚC</h1>
              </div>
            </Col>
            {(macaDishes.text || []).map((text, i) => {
              return (
                <Editable
                  editable={editable}
                  key={text.id}
                  object={text}
                  field="line"
                >
                  <Col sm={12} md={6}>
                    <p>{text.line}</p>
                  </Col>
                </Editable>
              );
            })}
          </Row>
        </Container>

        <Container className="dishes-container">
          <Row>
            <Col sm={12} md={6} className="dishes">
              <Figure className="dish-1">
                <Editable editable={editable} key={images[0]}>
                  <Image src={this.imageUrl(images[0])} />
                </Editable>
              </Figure>
              <Container fluid>
                <Row>
                  <Col xs={6} id="dish-2" className="dishes">
                    <Figure className="dish-2">
                      <Editable editable={editable} key={images[1]}>
                        <Image src={this.imageUrl(images[1])} />
                      </Editable>
                    </Figure>
                  </Col>
                  <Col xs={6} id="dish-3" className="dishes">
                    <Figure className="dish-3">
                      <Editable editable={editable} key={images[2]}>
                        <Image src={this.imageUrl(images[2])} />
                      </Editable>
                    </Figure>
                  </Col>
                </Row>
              </Container>
            </Col>
            <Col xs={6} md={3} className="dishes">
              <Figure className="dish-4">
                <Editable editable={editable} key={images[3]}>
                  <Image src={this.imageUrl(images[3])} />
                </Editable>
              </Figure>
              <Figure className="dish-5">
                <Editable editable={editable} key={images[4]}>
                  <Image src={this.imageUrl(images[4])} />
                </Editable>
              </Figure>
            </Col>
            <Col xs={6} md={3} className="dishes">
              <Figure className="dish-6">
                <Editable editable={editable} key={images[5]}>
                  <Image src={this.imageUrl(images[5])} />
                </Editable>
              </Figure>
              <Figure className="dish-7">
                <Editable editable={editable} key={images[6]}>
                  <Image src={this.imageUrl(images[6])} />
                </Editable>
              </Figure>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    content: state.content,
    images: state.images,
  };
};

export default connect(mapStateToProps)(MacaDishes);
